var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 14.0059C25.6667 14.0059 19.8333 18.6711 17.5 28.0015C21 23.3363 25.0833 21.5877 29.75 22.7529C32.4129 23.4179 34.316 25.3502 36.4233 27.4882C39.8533 30.9692 43.8244 35 52.5 35C61.8333 35 67.6667 30.3348 70 21.0029C66.5 25.6682 62.4167 27.4182 57.75 26.2529C55.0885 25.5879 53.1854 23.6557 51.0781 21.5177C47.6467 18.0352 43.6742 14.0059 35 14.0059ZM17.5 35C8.16667 35 2.33333 39.6652 0 48.9971C3.5 44.3319 7.58333 42.5819 12.25 43.7486C14.9115 44.415 16.8146 46.3459 18.9219 48.4823C22.3533 51.9648 26.3258 55.9957 35 55.9957C44.3333 55.9957 50.1667 51.3304 52.5 41.9986C49 46.6638 44.9167 48.4138 40.25 47.2471C37.5871 46.5821 35.684 44.6498 33.5767 42.5134C30.1467 39.0309 26.1756 35 17.5 35Z",
    fill: "#00ACC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.0d4183bf7024a10460952110c50c7849.svg";
export { ForwardRef as ReactComponent };